import React from "react";
import { useLocalStore, useObserver } from "mobx-react";
import { Spinner } from "@components";
import { useNavigation } from "@navigation";
import { AccommodationEditorStore } from "./AccommodationEditorStore";
import AccommodationForm from "./AccommodationForm";
import { FormData } from "./utils";

type Props = {
  id?: string;
  initialData?: Partial<FormData>;
  onClose?: () => void;
};

export function AccommodationEditor(props: Props) {
  const navigation = useNavigation();
  const localStore = useLocalStore(
    () => new AccommodationEditorStore(navigation, props.id, props.initialData)
  );

  return useObserver(() => {
    if (localStore.loading) {
      return <Spinner />;
    }
    return <AccommodationForm store={localStore} onClose={props.onClose} />;
  });
}
